import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
import { AppsEnum } from '../../../common/constants/app';
import { Container } from '../Container';
export const Image = props => {
    const { src, alt, app } = props.node.attrs;
    const isGiphy = app === AppsEnum.Giphy;
    return (_jsx(Container, { ...props, className: "inline-block", children: _jsx("img", { className: clsx('h-32 object-contain m-0', isGiphy && 'max-h-48'), src: src, alt: alt }, void 0) }, void 0));
};
//# sourceMappingURL=Image.js.map